/** MedCom/test patients whose name contains ZZTEST. */
export function isZzTestPatient(
  input:
    | {
        first_name?: string | null;
        last_name?: string | null;
        name?: string | null;
      }
    | string
    | null
    | undefined,
): boolean {
  const text =
    typeof input === 'string'
      ? input
      : [input?.first_name, input?.last_name, input?.name].filter(Boolean).join(' ');
  return text.toUpperCase().includes('ZZTEST');
}

export function defaultSendCourseCancellationEmail(
  patient:
    | {
        first_name?: string | null;
        last_name?: string | null;
        name?: string | null;
      }
    | string
    | null
    | undefined,
): boolean {
  return !isZzTestPatient(patient);
}
